// @flow

export const RECOMMENDATION_WIDGET_LIMIT_RULE_FIELD_BY_RECOMMENDATION_TYPE = {
  'frequently-bought-together': {
    conditions: 5,
    consequences: 5
  },
  'related-items': {
    conditions: 5,
    consequences: 5
  },
  bestsellers: {
    conditions: 5,
    consequences: 5
  },
  'hand-picked-products': {
    conditions: 1,
    consequences: 1
  }
};
export const RULE_OPTIONS_VALUES = {
  ALL_PRODUCTS: 'all-products',
  PRODUCT_ID: 'productId', //keep current logic
  ALL_COLLECTION: 'all-collections',
  COLLECTION: 'collectionId',
  PRICE: 'price',
  TAG: 'tag',
  VENDOR: 'vendor',
  PRODUCT_CATEGORY: 'product-category',
  PRODUCT_TYPE: 'product-type',
  // Default for Consequence - Bestsellers
  ALGORITHM: 'algorithm',
  REVIEWS_IO_RATING: 'reviewsio-rating',
  REVIEWS_IO_COUNT: 'total-reviewsio-rating'
};

export const PLACEHOLDER_BY_VALUE_OPTIONS = {
  [RULE_OPTIONS_VALUES.ALL_PRODUCTS]: null,
  [RULE_OPTIONS_VALUES.PRODUCT_ID]: 'AdminHTML.Recommendation.WidgetRule.productID_Placeholder', //keep current logic
  [RULE_OPTIONS_VALUES.ALL_COLLECTION]: null,
  [RULE_OPTIONS_VALUES.COLLECTION]: 'AdminHTML.Recommendation.WidgetRule.collection_Placeholder',
  [RULE_OPTIONS_VALUES.PRICE]: 'AdminHTML.Recommendation.WidgetRule.productPrice_Placeholder',
  [RULE_OPTIONS_VALUES.TAG]: 'AdminHTML.Recommendation.WidgetRule.productTag_Placeholder',
  [RULE_OPTIONS_VALUES.VENDOR]: 'AdminHTML.Recommendation.WidgetRule.productVendor_Placeholder',
  [RULE_OPTIONS_VALUES.PRODUCT_CATEGORY]:
    'AdminHTML.Recommendation.WidgetRule.productCategory_Placeholder',
  [RULE_OPTIONS_VALUES.PRODUCT_TYPE]: 'AdminHTML.Recommendation.WidgetRule.productType_Placeholder',
  // Default for Consequence - Bestsellers
  [RULE_OPTIONS_VALUES.ALGORITHM]: 'AdminHTML.Recommendation.WidgetRule.algorithm_Placeholder',
  [RULE_OPTIONS_VALUES.REVIEWS_IO_RATING]:
    'AdminHTML.Recommendation.WidgetRule.reviewsIORating_Placeholder',
  [RULE_OPTIONS_VALUES.REVIEWS_IO_COUNT]:
    'AdminHTML.Recommendation.WidgetRule.reviewsIOCount_Placeholder'
};

const CONDITION_RULE01_OPTIONS = [
  {
    label: 'AdminHTML.Recommendation.WidgetRule.allProducts_Label',
    value: RULE_OPTIONS_VALUES.ALL_PRODUCTS
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.productID_Label',
    value: RULE_OPTIONS_VALUES.PRODUCT_ID
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.collection_Label',
    value: RULE_OPTIONS_VALUES.COLLECTION
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.productCategory_Label',
    value: RULE_OPTIONS_VALUES.PRODUCT_CATEGORY
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.productType_Label',
    value: RULE_OPTIONS_VALUES.PRODUCT_TYPE
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.productVendor_Label',
    value: RULE_OPTIONS_VALUES.VENDOR
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.productTag_Label',
    value: RULE_OPTIONS_VALUES.TAG
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.productPrice_Label',
    value: RULE_OPTIONS_VALUES.PRICE
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.reviewsIORating_Label',
    value: RULE_OPTIONS_VALUES.REVIEWS_IO_RATING
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.reviewsIOCount_Label',
    value: RULE_OPTIONS_VALUES.REVIEWS_IO_COUNT
  }
];

const CONDITION_RULE02_OPTIONS = [
  {
    label: 'AdminHTML.Recommendation.WidgetRule.allCollections_Text',
    value: RULE_OPTIONS_VALUES.ALL_COLLECTION
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.collection_Label',
    value: RULE_OPTIONS_VALUES.COLLECTION
  }
];

export const CONDITION_RULE_OPTIONS_BESTSELLERS_BY_PAGE_TYPE = {
  'product-page': CONDITION_RULE01_OPTIONS,
  'collection-page': CONDITION_RULE02_OPTIONS,
  'home-page': [],
  'cart-page': [],
  'checkout-page': []
};

export const CONDITION_RULE_OPTIONS_FREQUENTLY_BOUGHT_TOGETHER_BY_PAGE_TYPE = {
  'product-page': CONDITION_RULE01_OPTIONS,
  'collection-page': [],
  'home-page': [],
  'cart-page': [],
  'checkout-page': []
};

export const CONDITION_RULE_OPTIONS_RELATED_ITEMS_BY_PAGE_TYPE = {
  'product-page': CONDITION_RULE01_OPTIONS,
  'collection-page': [],
  'home-page': [],
  'cart-page': [],
  'checkout-page': []
};

export const CONDITION_RULE_OPTIONS_HANDPICKED_BY_PAGE_TYPE = {
  'product-page': [
    {
      value: RULE_OPTIONS_VALUES.PRODUCT_ID,
      label: 'AdminHTML.Recommendation.Constants.productOption01_Label'
    }
  ],
  'collection-page': [
    {
      value: RULE_OPTIONS_VALUES.COLLECTION,
      label: 'AdminHTML.Recommendation.Constants.productOption02_Label'
    }
  ],
  'home-page': [],
  'cart-page': [],
  'checkout-page': []
};

export const CONDITION_RULE_OPTIONS = {
  bestsellers: CONDITION_RULE_OPTIONS_BESTSELLERS_BY_PAGE_TYPE,
  'hand-picked-products': CONDITION_RULE_OPTIONS_HANDPICKED_BY_PAGE_TYPE,
  'frequently-bought-together': CONDITION_RULE_OPTIONS_FREQUENTLY_BOUGHT_TOGETHER_BY_PAGE_TYPE,
  'related-items': CONDITION_RULE_OPTIONS_RELATED_ITEMS_BY_PAGE_TYPE
};

// for bestsellers | frequently bought together | related items consequence options
export const CONSEQUENCE_RULE_OPTIONS_01 = [
  {
    label: 'AdminHTML.Recommendation.WidgetRule.algorithm_Label',
    value: RULE_OPTIONS_VALUES.ALGORITHM
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.productID_Label',
    value: RULE_OPTIONS_VALUES.PRODUCT_ID
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.collection_Label',
    value: RULE_OPTIONS_VALUES.COLLECTION
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.productCategory_Label',
    value: RULE_OPTIONS_VALUES.PRODUCT_CATEGORY
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.productType_Label',
    value: RULE_OPTIONS_VALUES.PRODUCT_TYPE
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.productVendor_Label',
    value: RULE_OPTIONS_VALUES.VENDOR
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.productTag_Label',
    value: RULE_OPTIONS_VALUES.TAG
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.productPrice_Label',
    value: RULE_OPTIONS_VALUES.PRICE
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.reviewsIORating_Label',
    value: RULE_OPTIONS_VALUES.REVIEWS_IO_RATING
  },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.reviewsIOCount_Label',
    value: RULE_OPTIONS_VALUES.REVIEWS_IO_COUNT
  }
];

export const CONSEQUENCE_RULE_OPTIONS_HANDPICKED = [
  {
    label: 'AdminHTML.Recommendation.WidgetRule.productID_Label',
    value: RULE_OPTIONS_VALUES.PRODUCT_ID
  }
];

export const CONSEQUENCE_RULE_OPTIONS = {
  bestsellers: CONSEQUENCE_RULE_OPTIONS_01,
  'hand-picked-products': CONSEQUENCE_RULE_OPTIONS_HANDPICKED,
  'frequently-bought-together': CONSEQUENCE_RULE_OPTIONS_01,
  'related-items': CONSEQUENCE_RULE_OPTIONS_01
};

export const ALL_CONDUCTOR_LIST = {
  // Conductors allow select value
  EQUAL: 'equal', // is
  NOT_EQUAL: 'not_equal', // is not
  GREATER_THAN: 'greater_than', // >
  GREATER_EQUAL_THAN: 'greater_equal_than', // >=
  LESS_THAN: 'less_than', // <
  LESS_EQUAL_THAN: 'less_equal_than', // <=
  CONTAINS: 'contains',
  // Conductors with no select value => value = null
  EQUAL_COLLECTION: 'equal_collection', // Equals currently viewed collection
  NOT_EQUAL_COLLECTION: 'not_equal_collection', // Doesn't equal currently viewed collection
  EQUAL_PRODUCT_CATEGORY: 'equal_product_category', //Equals currently viewed category
  NOT_EQUAL_PRODUCT_CATEGORY: 'not_equal_product_category', //Doesn't equal currently viewed category
  EQUAL_PRODUCT_TYPE: 'equal_product_type', //Equals currently viewed type
  NOT_EQUAL_PRODUCT_TYPE: 'not_equal_product_type', //Doesn't equal currently viewed type
  EQUAL_VENDOR: 'equal_vendor', //Equals viewed product's vendor
  NOT_EQUAL_VENDOR: 'not_equal_vendor', //Doesn't equals viewed product's vendor
  CONTAINS_ALL_TAGS: 'contains_all_tags', //Contains all matched tags of viewed products
  CONTAINS_MATCHED_TAGS: 'contains_matched_tags' //Contains any matched tags of viewed products
};

export const CONDUCTOR_FOR_SPECIFIC_VALUES = [
  ALL_CONDUCTOR_LIST.EQUAL,
  ALL_CONDUCTOR_LIST.NOT_EQUAL,
  ALL_CONDUCTOR_LIST.GREATER_THAN,
  ALL_CONDUCTOR_LIST.GREATER_EQUAL_THAN,
  ALL_CONDUCTOR_LIST.LESS_THAN,
  ALL_CONDUCTOR_LIST.LESS_EQUAL_THAN,
  ALL_CONDUCTOR_LIST.CONTAINS
];

export const CONDUCTOR_FOR_PRODUCT_ID = [
  { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
    value: ALL_CONDUCTOR_LIST.NOT_EQUAL
  }
];

export const CONDUCTOR_FOR_COLLECTION = [
  { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
  {
    label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
    value: ALL_CONDUCTOR_LIST.NOT_EQUAL
  }
];

export const CONDUCTOR_FOR_CONDITION_PRODUCT_PAGE_BY_TYPE = {
  [RULE_OPTIONS_VALUES.ALL_PRODUCTS]: [],
  [RULE_OPTIONS_VALUES.PRODUCT_ID]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.COLLECTION]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.PRODUCT_CATEGORY]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.PRODUCT_TYPE]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.VENDOR]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.TAG]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.PRICE]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessThan',
      value: ALL_CONDUCTOR_LIST.LESS_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterThan',
      value: ALL_CONDUCTOR_LIST.GREATER_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_Equal',
      value: ALL_CONDUCTOR_LIST.EQUAL
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessEqualThan',
      value: ALL_CONDUCTOR_LIST.LESS_EQUAL_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterEqualThan',
      value: ALL_CONDUCTOR_LIST.GREATER_EQUAL_THAN
    }
  ],
  [RULE_OPTIONS_VALUES.REVIEWS_IO_RATING]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterEqualThan',
      value: ALL_CONDUCTOR_LIST.GREATER_EQUAL_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_Equal',
      value: ALL_CONDUCTOR_LIST.EQUAL
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessEqualThan',
      value: ALL_CONDUCTOR_LIST.LESS_EQUAL_THAN
    }
  ],
  [RULE_OPTIONS_VALUES.REVIEWS_IO_COUNT]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterEqualThan',
      value: ALL_CONDUCTOR_LIST.GREATER_EQUAL_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_Equal',
      value: ALL_CONDUCTOR_LIST.EQUAL
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessEqualThan',
      value: ALL_CONDUCTOR_LIST.LESS_EQUAL_THAN
    }
  ]
};

export const CONDUCTOR_FOR_CONDITION_COLLECTION_PAGE_BY_TYPE = {
  [RULE_OPTIONS_VALUES.ALL_COLLECTION]: [],
  [RULE_OPTIONS_VALUES.COLLECTION]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ]
};

export const CONDUCTOR_FOR_CONSEQUENCE_PRODUCT_PAGE_BY_TYPE = {
  [RULE_OPTIONS_VALUES.ALGORITHM]: [],
  [RULE_OPTIONS_VALUES.PRODUCT_ID]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.COLLECTION]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_EqualCollectionInProduct',
      value: ALL_CONDUCTOR_LIST.EQUAL_COLLECTION
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_NotEqualCollectionInProduct',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL_COLLECTION
    },
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.PRODUCT_CATEGORY]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_EqualCategory',
      value: ALL_CONDUCTOR_LIST.EQUAL_PRODUCT_CATEGORY
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_NotEqualCategory',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL_PRODUCT_CATEGORY
    },
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.PRODUCT_TYPE]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_EqualProductType',
      value: ALL_CONDUCTOR_LIST.EQUAL_PRODUCT_TYPE
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_NotEqualProductType',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL_PRODUCT_TYPE
    },
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.VENDOR]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_EqualVendor',
      value: ALL_CONDUCTOR_LIST.EQUAL_VENDOR
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_NotEqualVendor',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL_VENDOR
    },
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.TAG]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_ContainAllTags',
      value: ALL_CONDUCTOR_LIST.CONTAINS_ALL_TAGS
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_ContainMatchedTags',
      value: ALL_CONDUCTOR_LIST.CONTAINS_MATCHED_TAGS
    },
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.PRICE]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessThan',
      value: ALL_CONDUCTOR_LIST.LESS_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterThan',
      value: ALL_CONDUCTOR_LIST.GREATER_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_Equal',
      value: ALL_CONDUCTOR_LIST.EQUAL
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessEqualThan',
      value: ALL_CONDUCTOR_LIST.LESS_EQUAL_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterEqualThan',
      value: ALL_CONDUCTOR_LIST.GREATER_EQUAL_THAN
    }
  ],
  [RULE_OPTIONS_VALUES.REVIEWS_IO_RATING]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterEqualThan',
      value: ALL_CONDUCTOR_LIST.GREATER_EQUAL_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_Equal',
      value: ALL_CONDUCTOR_LIST.EQUAL
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessEqualThan',
      value: ALL_CONDUCTOR_LIST.LESS_EQUAL_THAN
    }
  ],
  [RULE_OPTIONS_VALUES.REVIEWS_IO_COUNT]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterEqualThan',
      value: ALL_CONDUCTOR_LIST.GREATER_EQUAL_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_Equal',
      value: ALL_CONDUCTOR_LIST.EQUAL
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessEqualThan',
      value: ALL_CONDUCTOR_LIST.LESS_EQUAL_THAN
    }
  ]
};

export const CONDUCTOR_FOR_CONSEQUENCE_COLLECTION_PAGE_BY_TYPE = {
  [RULE_OPTIONS_VALUES.ALGORITHM]: [],
  [RULE_OPTIONS_VALUES.PRODUCT_ID]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.COLLECTION]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_EqualCollection',
      value: ALL_CONDUCTOR_LIST.EQUAL_COLLECTION
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_NotEqualCollection',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL_COLLECTION
    },
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.PRODUCT_CATEGORY]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.PRODUCT_TYPE]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.VENDOR]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.TAG]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.PRICE]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessThan',
      value: ALL_CONDUCTOR_LIST.LESS_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterThan',
      value: ALL_CONDUCTOR_LIST.GREATER_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_Equal',
      value: ALL_CONDUCTOR_LIST.EQUAL
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessEqualThan',
      value: ALL_CONDUCTOR_LIST.LESS_EQUAL_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterEqualThan',
      value: ALL_CONDUCTOR_LIST.GREATER_EQUAL_THAN
    }
  ],
  [RULE_OPTIONS_VALUES.REVIEWS_IO_RATING]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterEqualThan',
      value: ALL_CONDUCTOR_LIST.GREATER_EQUAL_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_Equal',
      value: ALL_CONDUCTOR_LIST.EQUAL
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessEqualThan',
      value: ALL_CONDUCTOR_LIST.LESS_EQUAL_THAN
    }
  ],
  [RULE_OPTIONS_VALUES.REVIEWS_IO_COUNT]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterEqualThan',
      value: ALL_CONDUCTOR_LIST.GREATER_EQUAL_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_Equal',
      value: ALL_CONDUCTOR_LIST.EQUAL
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessEqualThan',
      value: ALL_CONDUCTOR_LIST.LESS_EQUAL_THAN
    }
  ]
};

export const CONDUCTOR_FOR_CONSEQUENCE_HOMEPAGE_BY_TYPE = {
  [RULE_OPTIONS_VALUES.ALGORITHM]: [],
  [RULE_OPTIONS_VALUES.PRODUCT_ID]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.COLLECTION]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.PRODUCT_CATEGORY]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.PRODUCT_TYPE]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.VENDOR]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.TAG]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.PRICE]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessThan',
      value: ALL_CONDUCTOR_LIST.LESS_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterThan',
      value: ALL_CONDUCTOR_LIST.GREATER_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_Equal',
      value: ALL_CONDUCTOR_LIST.EQUAL
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessEqualThan',
      value: ALL_CONDUCTOR_LIST.LESS_EQUAL_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterEqualThan',
      value: ALL_CONDUCTOR_LIST.GREATER_EQUAL_THAN
    }
  ],
  [RULE_OPTIONS_VALUES.REVIEWS_IO_RATING]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterEqualThan',
      value: ALL_CONDUCTOR_LIST.GREATER_EQUAL_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_Equal',
      value: ALL_CONDUCTOR_LIST.EQUAL
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessEqualThan',
      value: ALL_CONDUCTOR_LIST.LESS_EQUAL_THAN
    }
  ],
  [RULE_OPTIONS_VALUES.REVIEWS_IO_COUNT]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterEqualThan',
      value: ALL_CONDUCTOR_LIST.GREATER_EQUAL_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_Equal',
      value: ALL_CONDUCTOR_LIST.EQUAL
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessEqualThan',
      value: ALL_CONDUCTOR_LIST.LESS_EQUAL_THAN
    }
  ]
};

export const CONDUCTOR_FOR_CONSEQUENCE_CART_PAGE_BY_TYPE = {
  [RULE_OPTIONS_VALUES.ALGORITHM]: [],
  [RULE_OPTIONS_VALUES.PRODUCT_ID]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.COLLECTION]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.PRODUCT_CATEGORY]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.PRODUCT_TYPE]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.VENDOR]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.TAG]: [
    { label: 'AdminHTML.Recommendation.WidgetRule.conductor_Is', value: ALL_CONDUCTOR_LIST.EQUAL },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_IsNot',
      value: ALL_CONDUCTOR_LIST.NOT_EQUAL
    }
  ],
  [RULE_OPTIONS_VALUES.PRICE]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessThan',
      value: ALL_CONDUCTOR_LIST.LESS_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterThan',
      value: ALL_CONDUCTOR_LIST.GREATER_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_Equal',
      value: ALL_CONDUCTOR_LIST.EQUAL
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessEqualThan',
      value: ALL_CONDUCTOR_LIST.LESS_EQUAL_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterEqualThan',
      value: ALL_CONDUCTOR_LIST.GREATER_EQUAL_THAN
    }
  ],
  [RULE_OPTIONS_VALUES.REVIEWS_IO_RATING]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterEqualThan',
      value: ALL_CONDUCTOR_LIST.GREATER_EQUAL_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_Equal',
      value: ALL_CONDUCTOR_LIST.EQUAL
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessEqualThan',
      value: ALL_CONDUCTOR_LIST.LESS_EQUAL_THAN
    }
  ],
  [RULE_OPTIONS_VALUES.REVIEWS_IO_COUNT]: [
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_GreaterEqualThan',
      value: ALL_CONDUCTOR_LIST.GREATER_EQUAL_THAN
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_Equal',
      value: ALL_CONDUCTOR_LIST.EQUAL
    },
    {
      label: 'AdminHTML.Recommendation.WidgetRule.conductor_LessEqualThan',
      value: ALL_CONDUCTOR_LIST.LESS_EQUAL_THAN
    }
  ]
};

export const CONDUCTOR_CONDITION_FOR_BESTSELLERS_BY_PAGE_TYPE = {
  'product-page': CONDUCTOR_FOR_CONDITION_PRODUCT_PAGE_BY_TYPE,
  'collection-page': CONDUCTOR_FOR_CONDITION_COLLECTION_PAGE_BY_TYPE,
  'home-page': null,
  'cart-page': null,
  'checkout-page': null
};

export const CONDUCTOR_CONDITION_FOR_AI_TYPE_BY_PAGE_TYPE = {
  'product-page': CONDUCTOR_FOR_CONDITION_PRODUCT_PAGE_BY_TYPE,
  'collection-page': null,
  'home-page': null,
  'cart-page': null,
  'checkout-page': null
};

export const CONDUCTOR_FOR_CONDITION_BY_RECOMMENDATION_TYPE = {
  bestsellers: CONDUCTOR_CONDITION_FOR_BESTSELLERS_BY_PAGE_TYPE,
  'frequently-bought-together': CONDUCTOR_CONDITION_FOR_AI_TYPE_BY_PAGE_TYPE,
  'related-items': CONDUCTOR_CONDITION_FOR_AI_TYPE_BY_PAGE_TYPE,
  'hand-picked-products': null
};

export const CONDUCTOR_CONSEQUENCE_FOR_BESTSELLERS_BY_PAGE_TYPE = {
  'product-page': CONDUCTOR_FOR_CONSEQUENCE_PRODUCT_PAGE_BY_TYPE,
  'collection-page': CONDUCTOR_FOR_CONSEQUENCE_COLLECTION_PAGE_BY_TYPE,
  'home-page': CONDUCTOR_FOR_CONSEQUENCE_HOMEPAGE_BY_TYPE,
  'cart-page': CONDUCTOR_FOR_CONSEQUENCE_CART_PAGE_BY_TYPE,
  'checkout-page': null
};

export const CONDUCTOR_CONSEQUENCE_FOR_AI_TYPE_BY_PAGE_TYPE = {
  'product-page': CONDUCTOR_FOR_CONSEQUENCE_PRODUCT_PAGE_BY_TYPE,
  'collection-page': null,
  'home-page': null,
  'cart-page': CONDUCTOR_FOR_CONSEQUENCE_CART_PAGE_BY_TYPE,
  'checkout-page': CONDUCTOR_FOR_CONSEQUENCE_CART_PAGE_BY_TYPE
};

export const CONDUCTOR_FOR_CONSEQUENCE_BY_RECOMMENDATION_TYPE = {
  bestsellers: CONDUCTOR_CONSEQUENCE_FOR_BESTSELLERS_BY_PAGE_TYPE,
  'frequently-bought-together': CONDUCTOR_CONSEQUENCE_FOR_AI_TYPE_BY_PAGE_TYPE,
  'related-items': CONDUCTOR_CONSEQUENCE_FOR_AI_TYPE_BY_PAGE_TYPE,
  'hand-picked-products': null
};

